import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { serviceBookings, getService, deleteBooking, exportBookingsFlat, exportBookingsWeekly } from './adminApi';

const WEEKDAY_FULL = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];

// Weekday name from an ISO date ("YYYY-MM-DD"), parsed in local time to avoid
// a UTC-offset shifting the day.
const weekdayName = (iso) => {
    if (!iso) return '';
    const [y, m, d] = String(iso).split('-').map(Number);
    return WEEKDAY_FULL[new Date(y, m - 1, d).getDay()] || '';
};

export default function Bookings() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [rows, setRows] = useState(null);
    const [service, setService] = useState(null);
    const [error, setError] = useState('');
    const [exporting, setExporting] = useState(false);

    const load = () => {
        Promise.all([serviceBookings(id), getService(id)])
            .then(([b, s]) => { setRows(b); setService(s); })
            .catch((e) => setError(e.message));
    };
    useEffect(load, [id]);

    const remove = async (b) => {
        if (!window.confirm('Удалить эту запись?')) return;
        try { await deleteBooking(b.id); load(); } catch (e) { setError(e.message); }
    };

    const runExport = async (fn) => {
        setError(''); setExporting(true);
        try { await fn(id); } catch (e) { setError(e.message); }
        finally { setExporting(false); }
    };

    const runWeeklyExport = async () => {
        const input = window.prompt('На сколько недель разбить таблицу?', '4');
        if (input === null) return;              // cancelled
        const weeks = parseInt(input, 10);
        if (!Number.isInteger(weeks) || weeks < 1) { setError('Введите число недель (≥ 1)'); return; }
        setError(''); setExporting(true);
        try { await exportBookingsWeekly(id, weeks); } catch (e) { setError(e.message); }
        finally { setExporting(false); }
    };

    if (error) return <div className="a-error">{error}</div>;
    if (!rows) return <div className="a-muted">Загрузка…</div>;

    // collect custom field labels present
    const labels = Array.from(new Set(rows.flatMap((r) => Object.keys(r.custom_fields_data || {}))));
    const isWeekly = service?.service_type === 'WEEKLY';

    return (
        <div>
            <div className="a-page-head">
                <div>
                    <button className="a-btn a-btn-sm" onClick={() => navigate('/admin/services')}>← Сервисы</button>
                    <h1 style={{ marginTop: 8 }}>Записи · {service?.name}</h1>
                </div>
                <div className="a-row" style={{ margin: 0, alignItems: 'center' }}>
                    <span className="a-tag">{rows.length} записей</span>
                    <button className="a-btn" disabled={exporting || rows.length === 0} onClick={() => runExport(exportBookingsFlat)}>
                        {exporting ? 'Экспорт…' : 'Excel (список)'}
                    </button>
                    {service?.service_type === 'WEEKLY' && (
                        <button className="a-btn a-btn-primary" disabled={exporting || rows.length === 0} onClick={runWeeklyExport}>
                            Excel (таблица по неделям)
                        </button>
                    )}
                </div>
            </div>

            {rows.length === 0 ? <div className="a-empty">Записей пока нет.</div> : (
                <table className="a-table">
                    <thead>
                        <tr>
                            {isWeekly && <th>День недели</th>}
                            <th>Дата</th><th>Время</th><th>Клуб</th>
                            {labels.map((l) => <th key={l}>{l}</th>)}
                            <th>Создана</th><th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((b) => (
                            <tr key={b.id}>
                                {isWeekly && <td>{weekdayName(b.date)}</td>}
                                <td>{b.date}</td>
                                <td>{b.time}</td>
                                <td>{[b.club_id, b.club_name].filter(Boolean).join(' · ') || '—'}</td>
                                {labels.map((l) => <td key={l}>{(b.custom_fields_data || {})[l] ?? '—'}</td>)}
                                <td className="a-nowrap">{b.created_at}</td>
                                <td><button className="a-btn a-btn-sm a-btn-danger" onClick={() => remove(b)}>×</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
